import { initVision } from './vision'

export function createVisionStage(defaults = {}) {
  let resources = null
  let config = {}
  let _disposed = false

  async function init(opts = {}) {
    config = Object.assign({}, defaults, opts.config || {})
    resources = await initVision(config)
    return resources
  }

  function start() {
    // nothing to run continuously; resources are ready
  }

  function stop() {
    // nothing ongoing
  }

  async function process(frame, state) {
    // Vision stage is passive; other stages will call into resources
    return
  }

  async function dispose() {
    if (_disposed) return
    _disposed = true
    if (!resources) return
    try {
      if (resources.faceLandmarker && typeof resources.faceLandmarker.close === 'function') {
        resources.faceLandmarker.close()
      }
    } catch (e) {}
    try {
      if (
        resources.faceLandmarkerImage &&
        typeof resources.faceLandmarkerImage.close === 'function'
      ) {
        resources.faceLandmarkerImage.close()
      }
    } catch (e) {}
    try {
      if (resources.segmenter && typeof resources.segmenter.close === 'function')
        resources.segmenter.close()
    } catch (e) {}
    try {
      if (resources.segmenterImage && typeof resources.segmenterImage.close === 'function')
        resources.segmenterImage.close()
    } catch (e) {}
    try {
      if (resources.hairSegmenterImage && typeof resources.hairSegmenterImage.close === 'function')
        resources.hairSegmenterImage.close()
    } catch (e) {}
    resources = null
  }

  function getResources() {
    return resources
  }

  return {
    init,
    start,
    stop,
    process,
    dispose,
    getResources
  }
}

export default { createVisionStage }
